import { render, staticRenderFns } from "./GeneralJournalHtmlTemplate.vue?vue&type=template&id=bfafc0b4&scoped=true"
import script from "./GeneralJournalHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./GeneralJournalHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./GeneralJournalHtmlTemplate.vue?vue&type=style&index=0&id=bfafc0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafc0b4",
  null
  
)

export default component.exports